import axios from "axios";
// export const API_URL = "https://127.0.0.1:9000/AtencionTerceros/api";
export const API_URL = "https://www.cardiogroups.com/AtencionTerceros/api";
export const authHeader = () => {
  const token = JSON.parse(localStorage.getItem("token"));
  if (token) {
    return { "x-access-token": token };
  } else {
    return {};
  }
};
export const login = async (docIdentidad, clave) => {
  try {
    return new Promise((resolve, reject) => {
      axios
        .post(`${API_URL}/login`, {
          docIdentidad,
          clave,
        })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          resolve(error.response);
        });
    });
  } catch (error) {
    return null;
  }
};